import { render, staticRenderFns } from "./internship.vue?vue&type=template&id=c95364d4&scoped=true"
import script from "./internship.vue?vue&type=script&lang=js"
export * from "./internship.vue?vue&type=script&lang=js"
import style0 from "./internship.vue?vue&type=style&index=0&id=c95364d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95364d4",
  null
  
)

export default component.exports